/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Apply the subscription state object
 *
 * @param  {Object} state
 * @param  {Object} subscription
 * @return {Promise}
 */
const SET_SUBSCRIPTION = (state, subscription) => {
    state.data = subscription
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the licenses on the state object
 *
 * @param  {Object} state
 * @param  {Array} licenses
 * @return {Promise}
 */
const SET_LICENSES = (state, licenses) => {
    state.licenses = licenses
}

/**
 * Set the available plans on the state object
 *
 * @param  {Object} state
 * @param  {Array} plans
 * @return {Promise}
 */
const SET_PLANS = (state, plans) => {
    state.plans = plans
}

/**
 * Set the upgrade options on the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_UPDATE_OPTIONS = (state, plans) => {
    state.planUpdateOptions = plans
}

/**
 * Successful upgrade
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Promise}
 */
const UPGRADE_SUCCESS = (state, data) => {}

/**
 * Failed upgrade
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
const UPGRADE_FAILURE = (state, err) => {
    console.log(err)
}

/**
 * Change the license preview total
 *
 * @param  {Object} state
 * @param  {Number} total
 * @return {Promise}
 */
const UPDATE_PREVIEW_LICENSES = (state, total) => {
    state.preview.licenses = total
}

/**
 * Set the license update preview data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SET_PREVIEW_DATA = (state, payload) => {
    state.preview.data = payload
    state.preview.loading = false
}

/**
 * Set the additional licenses preview loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_PREVIEW_LOADING = (state) => {
    state.preview.loading = true
}

/**
 * Reset the preview data to its original state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_PREVIEW_DATA = (state) => {
    state.preview.licenses = 0
    state.preview.data = {}
    state.preview.error = false
    state.preview.loading = false
}

/**
 * Set the license preview error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_PREVIEW_ERROR = (state) => {
    state.preview.error = true
    state.preview.loading = false
}

/**
 * Reset the license preview error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_PREVIEW_ERROR = (state) => {
    state.preview.error = false
}

export default {
    SET_PLANS,
    RESET_STATE,
    SET_LICENSES,
    UPGRADE_SUCCESS,
    UPGRADE_FAILURE,
    SET_PREVIEW_DATA,
    SET_SUBSCRIPTION,
    SET_PREVIEW_ERROR,
    RESET_PREVIEW_DATA,
    SET_UPDATE_OPTIONS,
    SET_PREVIEW_LOADING,
    RESET_PREVIEW_ERROR,
    UPDATE_PREVIEW_LICENSES
}



// WEBPACK FOOTER //
// ./src/state/modules/user/subscription/mutations.js